import type { FunctionComponent } from 'react'
import React, { useRef } from 'react'

import type { SharingData } from '../../../../generated/frontend'
import { SharingOptions } from '../../../../shared/components/Sharing'
import styles from './SocialSharing.module.scss'

export const SocialSharing: FunctionComponent<Props> = ({ data }) => {
  const sharingRef = useRef<HTMLDivElement | null>(null)

  if (!data) {
    return null
  }

  return (
    <div ref={sharingRef} className={styles.container}>
      <SharingOptions className={styles.sharingOptions} sharingData={data} />
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  data: SharingData
}
